export default __webpack_public_path__ + "assets/icons/logo.909073b4d2c9a458687fdd79532e0bd8.svg";